<div [formGroup]="udfForm">
  <mat-form-field *ngIf="type === 'dropDown'">
    <mat-select
      placeholder="{{ placeholder }}"
      formControlName="value"
      (selectionChange)="onUDFChange()"
      required = "{{required}}"
      panelClass="opt-auto-complete"
    >
      <div class="search-container">
        <input
          [formControl]="searchControl"
          placeholder="Search {{ placeholder }}"
          class="opt-auto-complete-input"
        />
      </div>
      <mat-option *ngFor="let option of filteredOptions" [value]="option.id">
        {{ option.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>



  <mat-form-field *ngIf="type == 'textbox'">
    <input
      matInput
      placeholder="{{ placeholder }}"
      formControlName="value"
      required = "{{required}}"
      (input)="onUDFChange()"
    />
  </mat-form-field>
  <mat-error *ngIf="udfForm.get('value').hasError('required') && udfForm.get('value').touched">
    Cost Center is Mandatory.
  </mat-error>
</div>

